import { render, staticRenderFns } from "./PropertyIcon.vue?vue&type=template&id=16a13d0c&"
import script from "./PropertyIcon.vue?vue&type=script&lang=js&"
export * from "./PropertyIcon.vue?vue&type=script&lang=js&"
import style0 from "./PropertyIcon.vue?vue&type=style&index=0&id=16a13d0c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports